import React from 'react';

import {
  SvgIcon,
  SvgIconProps,
} from '@waglabs/icons';

export const EnvelopeOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21.9 3.5H2.1c-.607 0-1.1.501-1.1 1.118v14.764A1.11 1.11 0 002.1 20.5h19.8c.607 0 1.1-.501 1.1-1.118V4.618A1.11 1.11 0 0021.9 3.5zM1.88 18.97V5.916l6.415 6.522L1.88 18.97zm.625.635l6.415-6.522 2.772 2.818c.088.09.202.134.308.134a.424.424 0 00.308-.134l2.772-2.818 6.415 6.522H2.505zm19.615-.635l-6.415-6.523 6.415-6.522V18.97zm0-14.316L12 14.944 1.88 4.654v-.036a.22.22 0 01.22-.223h19.8a.22.22 0 01.22.223v.036z"
      fill="#727272"
      fillRule="nonzero"
    />
  </SvgIcon>
);
